import {configureStore} from "@reduxjs/toolkit";
import userProfileCreatedReducer from './slices/userProfileCreated';
import workoutSetupReducer from './slices/workoutSetup';
import workoutFeedbackReducer from './slices/workoutFeedback';

export default configureStore({
  reducer: {
    userProfileCreatedData: userProfileCreatedReducer,
    workoutSetupData: workoutSetupReducer,
    workoutFeedbackData: workoutFeedbackReducer,
  },
});